export const APP_NAME: string = 'DIGITAL EXPORT DOCUMENT PLATFORM';
export const APP_NAME_SHORT: string = 'EXP DOC';
export const APP_COPYRIGHT_FULL: string =
  'Copyright © SCG Chemicals Public Company Limited (2023). All Rights Reserved.';
export const APP_COPYRIGHT_SHORT: string =
  'Copyright © SCG Chemicals Pub Co., Ltd (2023). All Rights Reserved.';
export const APP_HOME_PATH: string = '/home';
export const HTTP_HEADER_NOT_LOADING: string = 'x-NotShowLoading';
export const LINK_FOR_HELP: string = 'https://scg.service-now.com/myrequestscg';
export const LINK_FOR_USER_MANUAL_PDF: string =
  'https://expdocblobmanualqas.blob.core.windows.net/manual/xDocUserManual.pdf';
export const LOGIN_TYPE_INTERNAL: string = 'LOGIN_TYPE_INTERNAL';
export const LOGIN_TYPE_B2C: string = 'LOGIN_TYPE_B2C';

//============== Local Storage ==============
export const LS_LAST_ACTIVITY: string = 'lastActivity';
export const LS_ACCESS_TOKEN: string = 'accessToken';
export const LS_APP_TOKEN: string = 'appToken';
export const LS_APP_TOKEN_API: string = 'appTokenAPI';
export const LS_CURRENT_USER: string = 'currentUser';
export const LS_USER_ROLE: string = 'userRole';
export const LS_USER_GROUP: string = 'userGroup';
export const LS_USER_MENU: string = 'userMenu';
export const LS_USER_DETAIL: string = 'userDetail';
export const LS_REDIRECT_URL: string = 'redirectURL';
export const LS_SIDEBAR: string = 'sidebarStage';
export const LS_TOKEN_SCOPE: string = 'tokenScopes';
export const LS_LOGIN_TYPE: string = 'loginType';
export const LS_USER_ROLE_DEV: string = 'userRoleDev'; //For Dev
export const LS_CRITERIA_SEARCH_FOR_PRINTING: string =
  'searchCriteria.searchForPrinting';
export const LS_CRITERIA_SEARCH_DOC_REQUIRED_MASTER: string =
  'searchCriteria.documentRequiredMaster';
export const LS_CRITERIA_SEARCH_USER_MANAGEMENT: string =
  'searchCriteria.userManagement';
export const LS_IS_LOGOUT_ACTION: string = 'isLogoutAction';
export const LS_CRITERIA_KPI_MANAGEMENT: string =
  'searchCriteria.kpiManagement';
//============== File size ==============
export const FILE_SIZE_UNIT_BYTE: string = 'Byte';
export const FILE_SIZE_UNIT_KB: string = 'KB';
export const FILE_SIZE_UNIT_MB: string = 'MB';
export const FILE_SIZE_UNIT_GB: string = 'GB';
export const FILE_SIZE_UNIT_TB: string = 'TB';

//============== Group ==============
export const ROLE_GROUP_TREASURY: number = 1;
export const ROLE_GROUP_CS: number = 2;
export const ROLE_GROUP_EXPORT_CUSTOMER: number = 3;
export const ROLE_GROUP_ADMIN: number = 4;
export const ROLE_GROUP_SUPPORT_DIGITAL: number = 4;

//============== Role ==============
export const ROLE_INVOICE_SEARCH_DISPLAY: number = 1;
export const ROLE_INVOICE_DETAIL_DISPLAY: number = 2;
export const ROLE_INVOICE_DETAIL_MAINTAIN: number = 3;
export const ROLE_INVOICE_EXPORT_DOCUMENT_DISPLAY: number = 4;
export const ROLE_INVOICE_EXPORT_DOCUMENT_MAINTAIN: number = 5;
export const ROLE_INVOICE_DOCUMENT_REQUIRED_DISPLAY: number = 6;
export const ROLE_INVOICE_DOCUMENT_REQUIRED_MAINTAIN: number = 7;
export const ROLE_INVOICE_LOG_DETAIL_DISPLAY: number = 8;
export const ROLE_INVOICE_LOG_EXPORT_DOCUMENT_DISPLAY: number = 9;
export const ROLE_INVOICE_LOG_DOCUMENT_REQUIRED_DISPLAY: number = 10;
export const ROLE_INVOICE_LOG_REVISE_REQUEST_DISPLAY: number = 11;
export const ROLE_REQUEST_REVISE_CREATE_MAINTAIN: number = 12;
export const ROLE_REQUEST_REVISE_CHANGE_SUMMARY_MAINTAIN: number = 13;
export const ROLE_REQUEST_REVISE_EDIT_MAINTAIN: number = 14;
export const ROLE_REQUEST_REVISE_APPROVE_MAINTAIN: number = 15;
export const ROLE_REQUEST_REVISE_DISPLAY: number = 16;
export const ROLE_MASTER_DOCUMENT_REQUIRED_DISPLAY: number = 17;
export const ROLE_MASTER_DOCUMENT_REQUIRED_MAINTAIN: number = 18;
export const ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_DISPLAY: number = 19;
export const ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_MAINTAIN: number = 20;
export const ROLE_MASTER_USER_MANAGEMENT_DISPLAY: number = 21;
export const ROLE_MASTER_USER_MANAGEMENT_MAINTAIN: number = 22;
export const ROLE_MASTER_KPI_MANAGEMENT_DISPLAY: number = 23;
export const ROLE_MASTER_KPI_MANAGEMENT_MAINTAIN: number = 24;

//============== Menu ==============
export const MENU_home: number = 1;
export const MENU_EXPORT_DOCUMENT: number = 2;
export const MENU_MASTER_MANAGEMENT: number = 3;
export const MENU_SEARCH_INVOICE: number = 4;
export const MENU_SEARCH_INVOICE_RESTORE_CRITERIA: number = 5;
export const MENU_INVOICE_DETAIL: number = 6;
export const MENU_INVOICE_EXPORT_DOCUMENT: number = 7;
export const MENU_INVOICE_DOCUMENT_REQUIRED: number = 8;
export const MENU_CHANGE_LOG_INVOICE_DETAIL: number = 9;
export const MENU_CHANGE_LOG_INVOICE_EXPORT_DOCUMENT: number = 10;
export const MENU_CHANGE_LOG_INVOICE_DOCUMENT_REQUIRED: number = 11;
export const MENU_CHANGE_LOG_REVISE_REQUEST: number = 12;
export const MENU_CREATE_REVISE_REQUEST: number = 13;
export const MENU_CHANGE_SUMMARY_DETAILS_REVISE_REQUEST: number = 14;
export const MENU_EDIT_REVISE_REQUEST: number = 15;
export const MENU_APPROVE_REJECT_REVISE_REQUEST: number = 16;
export const MENU_VIEW_REVISE_REQUEST: number = 17;
export const MENU_DOCUMENT_REQUIRED_MASTER: number = 18;
export const MENU_PUBLIC_DOCUMENT_OWNER: number = 19;
export const MENU_USER_MANAGEMENT: number = 20;

//============== Group Setup ==============
export const GROUP_SETUP_MENU_SECTION_NONE: string = '-';
export const GROUP_SETUP_MENU_SECTION_CRITERIA: string = 'Criteria';
export const GROUP_SETUP_MENU_SECTION_CHANGE_LOG: string = 'Change Log';
export const GROUP_SETUP_MENU_SECTION_DETAILS: string = 'Details';
export const GROUP_SETUP_MENU_SECTION_EXPORT_DOCUMENT: string =
  'Export Document';
export const GROUP_SETUP_MENU_SECTION_REQUIRED_DOCUMENT: string =
  'Required Document';
export const GROUP_SETUP_MENU_SECTION_RESULT: string = 'Result';
export const GROUP_SETUP_MENU_TYPE_BUTTON: string = 'Button';
export const GROUP_SETUP_MENU_TYPE_FIELD: string = 'Field';
export const GROUP_SETUP_MENU_TYPE_ICON: string = 'Icon';
export const GROUP_SETUP_MENU_TYPE_PANEL: string = 'Panel';
export const GROUP_SETUP_MENU_TYPE_TAB: string = 'Tab';
export const GROUP_SETUP_MENU_TYPE_SECTION: string = 'Section';

//============== Page Mode ==============
export const PAGE_MODE_VIEW: string = 'VIEW';
export const PAGE_MODE_CREATE: string = 'CREATE';
export const PAGE_MODE_EDIT: string = 'EDIT';
export const PAGE_MODE_APPROVE: string = 'APPROVE';
export const PAGE_MODE_COMPLETE: string = 'COMPLETE';
export const PAGE_MODE_VIEW_CHANGE_SUMMARY: string = 'VIEW_CHANGE_SUMMARY';
export const PAGE_MODE_CREATE_CHANGE_SUMMARY: string = 'CREATE_CHANGE_SUMMARY';
export const PAGE_MODE_CHANGE_SUMMARY: string = 'CHANGE_SUMMARY';
export const PAGE_MODE_RESTORE_CRITERIA: string = 'RESTORE_CRITERIA';

//============== Data Mode ==============
export const DATA_MODE_MASTER: string = 'MASTER';
export const DATA_MODE_TRANSACTION: string = 'TRANSACTION';